<template>
  <v-container fluid>
    <v-toolbar>
      <v-toolbar-title>{{ $t('ABO_SERVICES.ITEM') }}</v-toolbar-title>

      <v-spacer />

      <v-btn dark color="indigo" @click="create()">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('ABO_SERVICES.ITEM') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <abo-services-list
        :meta="meta"
        :filters="filters"
        :items="aboServices"
        @show="edit"
        @refresh="refreshData"
      />
    </v-sheet>
  </v-container>
</template>

<script>
import AboServicesList from '@/modules/abo_services/components/AboServicesList';
import { mapActions, mapState } from 'vuex';
export default {
  name: 'AboServicesPage',
  components: { AboServicesList },

  data: () => ({
    meta: {},
    filters: {}
  }),

  computed: {
    ...mapState('abo_services', ['aboServices'])
  },

  methods: {
    ...mapActions('abo_services', ['getAboServices']),

    refreshData(params) {
      this.getAboServices(params).then(({ data }) => {
        this.meta = data.meta;
      });
    },

    edit(item) {
      this.$router.push({
        name: 'abo-services.show',
        params: { id: item.id }
      });
    },

    create() {
      this.$router.push({ name: 'abo-services.create' });
    }
  }
};
</script>
